import { isNil } from "lodash-es";
import { Nillable } from "../types/nillable";

export function numberedName(name: string, number: Nillable<number>): string {
  return isNil(number) ? name : `${number}. ${name}`;
}
